module.exports = __webpack_public_path__ + "media/MRI2A.b1d1eb15.mp3";